var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-bar"},[_c('a',{class:{ active: _vm.current === 'video' },attrs:{"href":"/publish"}},[_vm._v("视频创作中心")]),_c('a',{class:{ active: _vm.current === 'story' },attrs:{"href":"/story-publish"}},[_vm._v("文物故事开放平台")])])
}
var staticRenderFns = []

export { render, staticRenderFns }